import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing(4)};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: relative;

  width: 100%;
  height: 2.8rem;
`;

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
`;

export const Empty = styled.div`
  flex: 1;
`;
